import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import GoogleMapsKey from './components/GoogleMapsKey/GoogleMapsKey';
import googleMapsConfigStore from './store/googleMapsConfigStore';
import { TGoogleMapsSettings } from './types/googleMapsConfig';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import './style.scss';

const GoogleMapsConfig: FC = observer((): JSX.Element => {
  const { settings } = googleMapsConfigStore;

  useEffect(() => {
    googleMapsConfigStore.fetchGoogleMapsSettings();

    return () => googleMapsConfigStore.reset();
  }, []);

  const handleKeyChange = (field: keyof TGoogleMapsSettings) => (value: string | undefined) => {
    googleMapsConfigStore.changeSettings({ [field]: value });
  };

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t('google_map_key')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      <div className="google-maps-config__fields-wrapper">
        <GoogleMapsKey title="google_map_key_public" value={settings.publicGoogleApiKey} onChange={handleKeyChange('publicGoogleApiKey')} />
        <GoogleMapsKey title="google_map_key_private" value={settings.privateGoogleApiKey} onChange={handleKeyChange('privateGoogleApiKey')} />
      </div>

      <SettingControlsBlock onSubmit={googleMapsConfigStore.updateGoogleMapsSettings} />

      <LoadingOverlay visible={googleMapsConfigStore.isLoading} refreshing />
      <Prompt when={googleMapsConfigStore.isDataEdited} message={getPromptProps()} />
    </div>
  );
});

export default GoogleMapsConfig;
